// // const API_URL =
// //   process.env.REACT_APP_API_URL || "http://localhost:8000";

// // function getAuthHeaders() {
// //   const storedUser = localStorage.getItem("user");
// //   const user = storedUser ? JSON.parse(storedUser) : null;

// //   if (!user?.id) {
// //     throw new Error("User session not found. Please login again.");
// //   }

// //   return {
// //     "Content-Type": "application/json",
// //     "X-User-Id": String(user.id),
// //   };
// // }

// // export async function fetchBrands() {
// //   const res = await fetch(`${API_URL}/api/admin/brands`, { headers: getAuthHeaders() });
// //   if (!res.ok) throw new Error("Failed to fetch brands");
// //   return res.json();
// // }

// // export async function fetchUsers() {
// //   const res = await fetch(`${API_URL}/api/admin/users`, { headers: getAuthHeaders() });
// //   if (!res.ok) throw new Error("Failed to fetch users");
// //   return res.json();
// // }



// // export async function createUser(userData) {
// //   const res = await fetch(`${API_URL}/api/admin/users`, {
// //     method: "POST",
// //     headers: getAuthHeaders(),
// //     body: JSON.stringify(userData),
// //   });

// //   const data = await res.json().catch(() => ({}));

// //   if (!res.ok) {
// //     throw new Error(
// //       data.detail ||
// //       data.message ||
// //       `Failed to create user (${res.status})`
// //     );
// //   }

// //   return data;
// // }


// // export async function updateUser(userId, userData) {
// //   const res = await fetch(`${API_URL}/api/admin/users/${userId}`, {
// //     method: "PUT",
// //     headers: getAuthHeaders(),
// //     body: JSON.stringify(userData),
// //   });
// //   if (!res.ok) throw new Error("Failed to update user");
// //   return res.json();
// // }

// const API_URL =
//   process.env.REACT_APP_API_URL || "http://localhost:8000";

// function getAuthHeaders() {
//   const storedUser = localStorage.getItem("user");
//   const user = storedUser ? JSON.parse(storedUser) : null;

//   if (!user?.id) {
//     throw new Error("User session not found. Please login again.");
//   }

//   return {
//     "Content-Type": "application/json",
//     "X-User-Id": String(user.id),
//   };
// }

// export async function fetchBrands() {
//   const res = await fetch(`${API_URL}/api/brands`, {
//     method: "GET",
//     headers: getAuthHeaders(),
//   });
//   if (!res.ok) throw new Error("Failed to fetch brands");
//   return res.json();
// }

// export async function fetchUsers() {
//   const res = await fetch(`${API_URL}/api/admin/users`, { headers: getAuthHeaders() });
//   if (!res.ok) throw new Error("Failed to fetch users");
//   return res.json();
// }

// export async function createUser(userData) {
//   const res = await fetch(`${API_URL}/api/admin/users`, {
//     method: "POST",
//     headers: getAuthHeaders(),
//     body: JSON.stringify(userData),
//   });

//   const data = await res.json().catch(() => ({}));

//   if (!res.ok) {
//     throw new Error(
//       data.detail ||
//       data.message ||
//       `Failed to create user (${res.status})`
//     );
//   }

//   return data;
// }

// export async function updateUser(userId, userData) {
//   const res = await fetch(`${API_URL}/api/admin/users/${userId}`, {
//     method: "PUT",
//     headers: getAuthHeaders(),
//     body: JSON.stringify(userData),
//   });
//   if (!res.ok) throw new Error("Failed to update user");
//   return res.json();
// }

const API_URL =
  process.env.REACT_APP_API_URL || "http://localhost:8000";

function getAuthHeaders() {
  const storedUser = localStorage.getItem("user");
  const user = storedUser ? JSON.parse(storedUser) : null;

  if (!user?.id) {
    throw new Error("User session not found. Please login again.");
  }

  return {
    "Content-Type": "application/json",
    "X-User-Id": String(user.id),
  };
}

export async function fetchBrands() {
  const res = await fetch(`${API_URL}/api/brands`, {
    method: "GET",
    headers: getAuthHeaders(),
  });
  if (!res.ok) throw new Error("Failed to fetch brands");
  return res.json();
}

export async function fetchUsers() {
  const res = await fetch(`${API_URL}/api/admin/users`, { headers: getAuthHeaders() });
  if (!res.ok) throw new Error("Failed to fetch users");
  return res.json();
}

export async function createUser(userData) {
  const res = await fetch(`${API_URL}/api/admin/users`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify(userData),
  });

  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    throw new Error(
      data.detail ||
      data.message ||
      `Failed to create user (${res.status})`
    );
  }

  return data;
}

export async function updateUser(userId, userData) {
  const res = await fetch(`${API_URL}/api/admin/users/${userId}`, {
    method: "PUT",
    headers: getAuthHeaders(),
    body: JSON.stringify(userData),
  });
  if (!res.ok) throw new Error("Failed to update user");
  return res.json();
}